import script from "./WinCriteriaModal.vue?vue&type=script&setup=true&lang=js"
export * from "./WinCriteriaModal.vue?vue&type=script&setup=true&lang=js"

import "./WinCriteriaModal.vue?vue&type=style&index=0&id=cba78f94&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cba78f94"]])

export default __exports__